import React from 'react';
import { firstError } from '@/utils/errors';
import { states } from '@/constants/lifecycle';
import BackButton from '@/components/buttons/BackButton';
import CloseButton from '@/components/buttons/CloseButton';
import ForwardButton from '@/components/buttons/ForwardButton';
import TabActions from '@/components/tabs/TabActions';
import Selectors from '../hooks/selectors';
import { validateRequestSection } from '../helper';
import Events from '../hooks/events';

export const validateRequestProjectStep = ({ request, workflow }) => (
  validateRequestSection(request, workflow, 'project')
);

const ProjectInfoActions = ({
  category,
  code,
  compact,
  goBack,
  goForward,
}) => {
  const { readErrors, saveStatus, sourceUrl } = Selectors.useProjectInfoActions({ category, code });
  const cancelRequest = Events.useDestroyRequests();

  return (
    <TabActions className="aridhia-request-access-wizard-actions">
      <CloseButton
        disabled={saveStatus === states.PENDING}
        onClick={() => cancelRequest({
          items: [{ code, isNew: true, steps: { sourceUrl } }],
          isArchival: false,
          silent: true,
        })}
      />
      <BackButton onClick={goBack} disabled={saveStatus === states.PENDING} iconOnly={compact} />
      <ForwardButton
        onClick={goForward}
        iconOnly={compact}
        disabled={saveStatus === states.PENDING || firstError(readErrors)}
      />
    </TabActions>
  );
};

export default ProjectInfoActions;
